import { render, staticRenderFns } from "./SingleCreate.vue?vue&type=template&id=9dd376dc&"
import script from "./SingleCreate.vue?vue&type=script&lang=js&"
export * from "./SingleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports